export const frontmatter = {
    "title": "Conceptos clave",
    "description": "Los conceptos fundamentales de OnnIA: organizaciones, flujos, asistentes, canales, tickets y más.",
    "sidebar_label": "Conceptos clave",
    "sidebar_group": "conceptos",
    "sidebar_order": 2,
    "hide_title": true,
    "toc": false
}

export const toc = [
    {
        "depth": 2,
        "id": "organizacion",
        "value": "Organización"
    },
    {
        "depth": 2,
        "id": "automatizacion",
        "value": "Automatización"
    },
    {
        "depth": 2,
        "id": "tipos-de-asistente",
        "value": "Tipos de asistente"
    },
    {
        "depth": 2,
        "id": "atencion-y-clientes",
        "value": "Atención y clientes"
    },
    {
        "depth": 2,
        "id": "gobernanza",
        "value": "Gobernanza"
    }
]